/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { OurCustomersV2 } from 'ui/molecules/OurCustomers/OurCustomersV2';
import { DifferenceSection } from 'ui/organisms/DifferenceSection/DifferenceSection';

import styles from './BrowserExtensionPage.module.scss';

import { getHowToInstallItems, getWhyItems } from './BrowserExtensionPage.data';
import { ExtensionHeroSection } from './ExtensionHeroSection/ExtensionHeroSection';
import { DataSourcesSection } from './DataSourcesSection/DataSourcesSection';
import { RecordDestinationsSection } from './RecordDestinationsSection/RecordDestinationsSection';
import { WhereItWorksSection } from './WhereItWorksSection/WhereItWorksSection';
import { WhoUsesItSection } from './WhoUsesItSection/WhoUsesItSection';

const ArrowIcon = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M8 1.5v8.5M8 10 4.8 6.8M8 10l3.2-3.2"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.4 12v2.1h11.2V12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const BrowserExtensionPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <ExtensionHeroSection />

      <OurCustomersV2 hasBackground={false} />

      <DifferenceSection
        title={t('Six checks that normally cost you six tabs and twenty minutes.')}
        items={getWhyItems(t)}
      />

      <WhereItWorksSection />

      <RecordDestinationsSection />

      <WhoUsesItSection />

      <DataSourcesSection />

      <DifferenceSection
        title={t('Install the Global Database extension in six steps.')}
        description={t(
          'Free to install, no card required. About two minutes from the store listing to the panel opening on a company page.',
        )}
        items={getHowToInstallItems(t)}
        reverse
        actions={
          <Button type="blue" size="xl" href="https://www.globaldatabase.com/outreach" suffix={<ArrowIcon />}>
            {t('Install for free')}
          </Button>
        }
      />
    </div>
  );
};
